export default "__VITE_ASSET__Dm0kuLWa__"